import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { UPLOAD_FILE_ERROR } from "@src/common/helpers/toastIds";
import useAddDicomToCustomTest from "@src/modules/shared/components/Results/ResultsFormHeader/hooks/useAddDicomToCustomTest";
import { useField } from "formik";

const useCustomTestFileHandlers = () => {
  const { t } = useTranslation();

  const addFileMutation = useAddDicomToCustomTest();
  const [studyIdField] = useField<string>("studyId");
  const [testIdField] = useField<string>("testId");
  const fileHandler = async (file: File) => {
    let success = true;
    await addFileMutation.mutateAsync(
      {
        studyId: studyIdField.value,
        testId: testIdField.value,
        file,
      },
      {
        onError: () => {
          success = false;
          toast.error(`${t("Upload file error")}: ${file.name}`, {
            toastId: UPLOAD_FILE_ERROR,
          });
        },
      },
    );

    return success;
  };

  return { fileHandler };
};

export default useCustomTestFileHandlers;
